module.exports = "/images/vendor/flag-icon-css/flags/4x3/mn.svg?9ebe47ebe8928cd80ea971f6cc7a2760";